<template>
   <card>
      <template slot="header">
         <div class="row">
            <div class="col-md-4">
               <h3 class="card-title">Sub Departments</h3>
            </div>
         </div>
      </template>
      <div class="row">
         <div class=" col-md-6">
            <nav class="row">
               <ol class="breadcrumb arr-right bg-breadcrum">
                  <li class="breadcrumb-item">
                     <router-link to="dashboard"><i class="fa fa-home"></i>&nbspDashboard</router-link>
                  </li>
                  
                   <li class="breadcrumb-item">
                       <router-link to="department">&nbspDepartments</router-link>
                   </li>
                   <li class="breadcrumb-item active">Sub Departments</li>
               </ol>
            </nav>
         </div>
         <div class="col-md-6">
            <button class="btn btn-primary float-right" v-b-modal.add-new-item><i class="fa fa-plus"></i>&nbspSub Departments</button>
         </div>
      </div>
     <hr style="margin-top:-10px"/>
     <div class="table-responsive ">
        <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                 <tr>
                     <th width="70">ID</th>
                     <th width="300">Sub Department Name</th>
                     <th width="600">Description</th>
                     <th width="150">Action</th>
                 </tr>
             </thead>
            <tbody>
                <tr v-for="item,index in items">
                   <td>{{index+1}}</td>
                   <td><b>{{item.sub_department_name | capitalize}}</b></td>
                   <td><i>{{item.description}}</i></td>
                   <td><button class="btn btn-xs btn-default" @click="get_selected_item(item)" v-b-modal.update-sub-department ><i class="fa fa-pencil"></i>Modify</button></td>
                </tr>     
            </tbody>    
        </table>
      </div>  
       <!-- MODAL FOR ADD NEW ITEM -->
        <b-modal id="add-new-item" ref="add-new-sub-department"  size="l"   title="New Sub Department"  hide-footer>
            <h3>Sub Department</h3>
            <div class="form-group">
               <label>Sub Deparment Name:</label>
               <input type="text" class="form-control" v-model="sub_department_name">
            </div>
            <div class="form-group">
               <label>Description:</label>
               <textarea class="form-control"  rows="6" v-model="description"></textarea>
            </div>
            </div>
            <div class="form-group">
               <button class="btn btn-info float-right" @click="add_sub_departments"><i class="fa fa-save"></i> Submit form</button>
            </div>
         </b-modal> 
       <!-- MODAL UPDATE -->
       <b-modal id="update-sub-department" ref="update-sub-department" size="l" title="Update Item" hide-footer>
            <h3>Sub Deparment</h3>
            <div class="form-group">
                <label>Sub Deparment Name:</label>
                <input type="text" class="form-control" v-model="selected_item.sub_department_name">
            </div>
            <div class="form-group">
                <label>Description:</label>
                <textarea class="form-control"  rows="6" v-model="selected_item.description"></textarea>
            </div>
            <div class="form-group">
                <button class="btn btn-info float-right" @click="update_sub_department"><i class="fa fa-save"></i> Submit form</button>
            </div>
       </b-modal>   
      <!-- If Lost Connection on Server -->   
      <template v-if="display_indicator === 1">
         <center>
            <br/><br/>
            <img  src="/static/img/warning.png"  width="225" height="190">
            <h1>You've lost your network connection</h1>
            <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
            <br/><br/>
         </center>
      </template>
   </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'  
export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      sub_department_name: "",
      description: "",
      selected_item: "",
      loading: true,
      display_indicator: ""
    }
  },

  mounted: function() {
    this.get_sub_departments()
    setTimeout(() => {
      this.loading = false
    }, 300)
  },

  methods: {
    get_sub_departments() {
      axios
        .get("api/subdepartments")
        .then(response => {
          this.items = response.data
          this.display_indicator = 2
        })
        .catch(e => {
          console.log(e.response)
          this.display_indicator = 1
        })
    },
   add_sub_departments(){
       axios 
           .post("api/subdepartments/add",
            {
              sub_department_name:this.sub_department_name,
              description:this.description
            })
           .then(resp => {
                if(resp.data.response == "success"){
                    this.$swal({
                        type: "success",
                        title: "Save",
                        text: resp.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                    this.get_sub_departments()
                    this.$refs["add-new-sub-department"].hide()
                }else if(resp.data.response == "error"){
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: resp.data.message,
                        showConfirmButton: true
                    });
                }
            })
           .catch(error => {
               console.log(resp) 
           })
   },
   update_sub_department(){
         axios
            .post("api/subdepartment/update/" + this.selected_item.id,
             {
                sub_department_name:this.selected_item.sub_department_name,
                description:this.selected_item.description
             }
            )
            .then(resp => {
                if(resp.data.response == "success"){
                    this.$swal({
                        type: "success",
                        title: "Save",
                        text: resp.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                    this.get_sub_departments()
                    this.$refs["update-sub-department"].hide()
                }
            })
            .catch(error => {
                console.log(error)
            })
   },
   get_selected_item(item){
       this.selected_item = item
       console.log(this.selected_item)
   }
  },
  computed: {
    departmentItem() {
      let filterd = this.items
      if (filterd.length > 0) {
        filterd.slice().reverse()
      }
      return filterd
    }
  },

}
</script>

        


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-departments/todo-sub-department.vue